<template>
  <div v-if="show" class="t-Modal" @click="clickOutside">
    <div class="t-Modal-Content" :class="{ '-bounce': bounce }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    persistent: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      bounce: false,
    };
  },
  methods: {
    clickOutside(e) {
      if (!this.persistent && e.target.className === 't-Modal') {
        this.$emit('input', false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.t-Modal {
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  left: 0;
  padding: 24px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99997;

  .-bounce {
    animation: bounce-in 0.2s;
  }
}

.t-Modal-Content {
  animation: show-in 0.2s;
  background: var(--track-color-white);
  border-radius: 4px;
  box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px rgb(0 0 0 / 14%), 0 1px 10px rgb(0 0 0 / 12%);
  max-height: calc(100vh - 48px);
  overflow: auto;
}

@keyframes show-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
